import { useQuery } from '@tanstack/react-query'
import { fetchCurrentUser } from '@/api/users'

// This fires unconditionally on every page, including the public sign-in/sign-up pages —
// CurrentHouseholdProvider mounts it before any user exists, so it 401s there. That's fine on
// its own (react-query just shows an error state nothing renders); what isn't fine is treating
// that 401 as a session-expiry event — see api/client.ts's onPublicPage() guard.
export function useCurrentUser() {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
    staleTime: Infinity,
  })
}
